export const nameofFactory = <T>() => (name: keyof T) => name;


// WEBPACK FOOTER //
// ./src/utils/nameofFactory.ts